import React, { useEffect, useState } from 'react'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/scrollbar'
import { Autoplay, Mousewheel, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Promotions } from '../Utils/API'

function PromotionsSlider() {
    const [promotions, setPromotions] = useState([])

    useEffect(() => {
        try {
            Promotions().then(res => {
                if (res?.data?.status === 'success' && res?.data?.data?.length > 0) {
                    const activePromotions = res?.data?.data.filter(item => item.slide_is_active)
                    setPromotions(activePromotions)
                }
            })
        } catch (error) {
            console.log('error', error)
        }
    }, [])

    return (
        <Swiper
            spaceBetween={20}
            slidesPerView={1}
            mousewheel={true}
            autoplay={{
                delay: 5500,
                disableOnInteraction: false,
            }}
            pagination={{
                clickable: true,
            }}
            breakpoints={{
                320: { 
                    slidesPerView: 1,
                    spaceBetween: 10,
                },
                640: { 
                    slidesPerView: 1.5,
                    spaceBetween: 15,
                },
                768: { 
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                1024: { 
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
            }}
            modules={[Autoplay, Pagination, Mousewheel]}
            className="my-4"
        >
            {promotions?.map((item, index) => (
                <SwiperSlide key={index}>
                    <div className="relative w-full max-w-md h-28 rounded-xl overflow-hidden shadow-md mx-auto">                        
                        <div
                            className="absolute inset-0 bg-cover bg-center"
                            style={{
                                backgroundImage: `url('${encodeURI(item.slide_url)}')`,
                            }}
                        ></div>
                    </div>
                </SwiperSlide>
            ))}
        </Swiper>
    )
}

export default PromotionsSlider
